export default __webpack_public_path__ + "assets/images/Blurs-8e82536499bb977f647b2434756eeff9.png";